var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 7.94683C9.82625 7.94683 11.3067 6.46638 11.3067 4.64016C11.3067 2.81394 9.82625 1.3335 8.00003 1.3335C6.1738 1.3335 4.69336 2.81394 4.69336 4.64016C4.69336 6.46638 6.1738 7.94683 8.00003 7.94683Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1332 14.6667C13.2422 14.6729 13.3512 14.6556 13.4529 14.6158C13.5545 14.5761 13.6464 14.5149 13.7224 14.4365C13.7983 14.358 13.8564 14.2642 13.8928 14.1613C13.9291 14.0583 13.9429 13.9488 13.9332 13.8401C13.5065 11.3334 11.0132 9.40674 7.99985 9.40674C4.98651 9.40674 2.49318 11.3334 2.06651 13.8401C2.05676 13.9488 2.07055 14.0583 2.10693 14.1613C2.14331 14.2642 2.20143 14.358 2.27734 14.4365C2.35325 14.5149 2.44516 14.5761 2.54683 14.6158C2.6485 14.6556 2.75753 14.6729 2.86651 14.6667H13.1332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.639fe4032a2b57e257ffd76dcc022af7.svg";
export { ForwardRef as ReactComponent };